module.exports = __webpack_public_path__ + "img/front_buttons_quantity.f0fc1ac3.png";